// eslint-disable-next-line import/no-amd
define([ 'jquery', './jquery.gm' ], ($) => {

	const GMAP_KEY = 'AIzaSyD1Arw77K0ngiTRnIkPosMJKZqYO3Ttowk'; // TODO generovat do sablon

	const projectConfig = window.projectConfig || {};

	projectConfig.googlemaps = projectConfig.googlemaps || {};
	projectConfig.googlemaps.activeMarker = null;
	projectConfig.googlemaps.showAllMarkersOnEmptyFilter = true;

	// create googlemap card
	projectConfig.googlemaps.createCard = (data) => {
		let str = '';
		let titlePrefix = '';
		str += '<div class="googleMapCardIn">';
		// str += '<div class="clearfix">';

		str += '<div class="googleMapCardStreetViewCnt">';
		if ( data.branchType === 'ws' ) {
			if ( (data.title).indexOf('Obchodní zastoupení ') === -1 ) {
				titlePrefix = 'Obchodní zastoupení ';
			}
			str += '<div class="withoutStreetView">';
			str += '<img src="/img/google-map/koop-without-streetview.png" alt="" />';
			str += '</div>';
		} else if ( data.branchType === 'csas' ) {
			titlePrefix = 'Česká spořitelna - ';
		} else if ( data.branchType === 'koop' ) {
			titlePrefix = 'Kooperativa - ';
		}
		str += '</div>';// .googleMapCardStreetViewCnt

		str += '<div class="googleMapCardContentCnt">';
		str += `<h3>${ titlePrefix }${ data.title }</h3>`;
		str += '<address>';
		if ( data.street && data.street !== '' ) {
			str += `<p>${ data.street }${ (data.num && data.num !== '') ? ` ${ data.num }` : '' }</p>`;
		}
		if ( data.city && data.city !== '' ) {
			str += `<p>${ data.city }</p>`;
			if ( data.zip && data.zip !== '' ) {
				str += `<p>${ data.zip }</p>`;
			}
		}
		if ( data.phone && (!(data.phone === '' || data.phone.toLowerCase() === 'null')) ) {
			str += `<p><strong>tel: </strong>${ data.phone }</p>`;
		}
		if ( data.fax && (!(data.fax === '' || data.fax.toLowerCase() === 'null')) ) {
			str += `<p><strong>fax: </strong>${ data.fax }</p>`;
		}
		if ( data.email && (!(data.email === '' || data.email.toLowerCase() === 'null')) ) {
			str += `<p><strong>e-mail: </strong>${ data.email }</p>`;
		}
		str += '</address>';
		if ( data.openingHours ) {
			// pobočky uzavřeny
			str += '<h4>Otevírací doba</h4>';
			str += '<table>';
			str += formatOpeningHours('Pondělí', data.openingHours.mo);
			str += formatOpeningHours('Úterý', data.openingHours.tu);
			str += formatOpeningHours('Středa', data.openingHours.we);
			str += formatOpeningHours('Čtvrtek', data.openingHours.th);
			str += formatOpeningHours('Pátek', data.openingHours.fr);
			str += formatOpeningHours('Sobota', data.openingHours.st);
			str += formatOpeningHours('Neděle', data.openingHours.su);
			str += '</table>';
		}
		if ( data.description && data.description !== '' ) {
			str += `<div class="googleMapCardDescription">${ data.description }</div>`;
		}
		str += '</div>'; // .googleMapCardContentCnt

		str += '<span class="googleMapCardClose">Zavřít</span>';
		// str += '</div>'; // .clearfix
		str += '</div>'; // .googleMapCardIn

		return str;

	};

	// activate close button
	projectConfig.googlemaps.detectStreetViewImage = (marker, data) => {
		const $card = $('.googleMapCard', $(marker.container).parent());

		if ( data.branchType === 'csas' ) {
			const baseParams = `size=287x420&fov=90&heading=235&pitch=10&location=${ (data.lat).toString() },${ (data.lng).toString() }&key=${ GMAP_KEY }`;
			const url = `https://maps.googleapis.com/maps/api/streetview/metadata?${ baseParams }`;
			const imgUrl = `<img class="googleMapCardStreetViewThumbnail" src="https://maps.googleapis.com/maps/api/streetview?${ baseParams }" alt="" />
<img class="googleMapCardMapThumbnail" src="/img/google-map/map-placeholder.jpg" width="auto" height="420" alt="" />
<button class="btn" id="gmapStreetViewTrigger">Street view</button><button class="btn" id="gmapMapTrigger">Mapa</button>`;

			$.getJSON(url, (jsonData) => {
				if ( jsonData.status === 'OK' ) {
					$('.googleMapCardStreetViewCnt', $card).html(imgUrl);
					$('.googleMapCardMapThumbnail, #gmapMapTrigger').hide();
					$('.googleMapCardStreetViewThumbnail', $card).on('load', () => {
						if ( $('#gmapMapTrigger').is(':hidden') ) {
							$('.googleMapCardStreetViewCnt #gmapStreetViewTrigger', $card).fadeIn();
						}
					});

					const panorama = marker.map.getStreetView();

					const latLng = new google.maps.LatLng(data.lat, data.lng);
					panorama.setPosition(latLng);
					panorama.setPov({
						heading: 0,
						pitch:   0,
					});

					const showPanorama = () => {
						panorama.setVisible(true);
						$('.googleMapCardStreetViewThumbnail, #gmapStreetViewTrigger').hide();
						$('.googleMapCardMapThumbnail').css({ 'display': 'block' });
						$('#gmapMapTrigger').show();
					};

					const hidePanorama = () => {
						panorama.setVisible(false);
						$('.googleMapCardMapThumbnail, #gmapMapTrigger').hide();
						$('.googleMapCardStreetViewThumbnail').css({ 'display': 'block' });
						$('#gmapStreetViewTrigger').show();
					};

					const pointerPanoramaOn = document.getElementById('gmapStreetViewTrigger');
					google.maps.event.addDomListener(pointerPanoramaOn, 'click', showPanorama);

					const pointerPanoramaOff = document.getElementById('gmapMapTrigger');
					google.maps.event.addDomListener(pointerPanoramaOff, 'click', hidePanorama);

				} else {
					$('.googleMapCardStreetViewCnt', $card).html('<div class="withoutStreetView"><img src="/img/google-map/koop-without-streetview.png" alt="" /></div>');
				}
			});
		} else if ( data.branchType === 'koop' ) {
			if ( data.motiveFile !== null ) {
				$('.googleMapCardStreetViewCnt', $card).html(`<div class="staticMotive" style="background-image: url(${ data.motiveFile })"></div>`);
			} else {
				$('.googleMapCardStreetViewCnt', $card).html('<div class="withoutStreetView"><img src="/img/google-map/koop-without-streetview.png" alt="" /></div>');
			}
		}
	};

	// vyhledávání nad mapou
	projectConfig.googlemaps.handleSearchInput = () => {
		$(document).on('submit', '.gmapBranchesForm', (e) => {
			e.preventDefault();
			const gmapInputText = $('input[type="text"]', e.target).val();
			const bounds = new google.maps.LatLngBounds();

			if ( $('#branches').length && typeof window.scrollToAnchor === 'function' ) {
				window.scrollToAnchor('#branches');
			}

			$(document).trigger('FG_UNIVERSAL_PRELOADER_START', 'GMAP');
			$('#googleMap').googlemap('filterObjects', 'markers', {}, {
				fulltextData: [ gmapInputText ],
			}, {
				onMarkerSuccess(marker) {
					bounds.extend(marker.position);

					setTimeout(() => {
						$('#googleMap').googlemap('zoomToMarkersBoundsCustom', bounds);
						$(document).trigger('FG_UNIVERSAL_PRELOADER_STOP', 'GMAP');
					}, 1000);

				},
			});
		});
	};

	projectConfig.googlemaps.handleCloseCard = (marker) => {
		const $card = $('.googleMapCard', $(marker.container).parent());
		$('.googleMapCardClose', $card).bind('click', () => {
			const inactiveIcon = {
				url:    '/img/google-map/koop-marker-01.png',
				size:   new google.maps.Size(48, 64),			// size of marker in px [x - width, y - height]
				origin: new google.maps.Point(0, 0),		// position of marker image in sprite (if given) [x - position from the left, y - position from the top]
				anchor: new google.maps.Point(24, 64),		// tip of the marker [x - from the left, y - from the top]
			};
			projectConfig.googlemaps.activeIcon.setOptions({
				icon: inactiveIcon,
			});
			marker.opened = false;
			$card.empty().hide();
			$('.gmap-branches-cnt').removeClass('gmap-branches-cnt-active');
		});
	};

	projectConfig.googlemaps.resizeMapOnEvent = () => {
		if ( window.innerWidth <= 348 ) {
			$('#googleMap').googlemap('setCenterAndZoom', {
				lat:  50.0701842,
				lng:  15.5009503,
				zoom: 5,
			});
		} else if ( (window.innerWidth >= 359) && (window.innerWidth <= 659) ) {
			$('#googleMap').googlemap('setCenterAndZoom', {
				lat:  50.0701842,
				lng:  15.5009503,
				zoom: 6,
			});
		} else if ( (window.innerWidth >= 660) && (window.innerWidth <= 1052) ) {
			$('#googleMap').googlemap('setCenterAndZoom', {
				lat:  50.0701842,
				lng:  15.5009503,
				zoom: 7,
			});
		} else if ( window.innerWidth >= 1053 ) {
			$('#googleMap').googlemap('setCenterAndZoom', {
				lat:  49.7701842,
				lng:  15.6009503,
				zoom: 8,
			});
		}
	};

	const formatOpeningHours = (dayLabel, dayData) => {
		let str = '';
		if (
			dayData &&
			dayData.hours &&
			dayData.hours[ 0 ] &&
			(!(
				dayData.hours[ 0 ].from === '00:00' &&
				dayData.hours[ 0 ].to === '00:00' &&
				dayData.hours[ 1 ].from === '00:00' &&
				dayData.hours[ 1 ].to === '00:00'
			))
		) {
			str += '<tr>';
			str += `<td>${ dayLabel }</td>`;
			if ( dayData.hours[ 0 ] ) {
				str += `<td><strong>${ dayData.hours[ 0 ].from } - ${ dayData.hours[ 0 ].to }</strong></td>`;
			}
			if ( dayData.hours[ 1 ] ) {
				str += `<td><strong>${ dayData.hours[ 1 ].from } - ${ dayData.hours[ 1 ].to }</strong></td>`;
			}
			str += '</tr>';
		}
		return str;
	};
});



// WEBPACK FOOTER //
// ./config/fe/web-default/src/js/web/jquery.gm.conf.js